export const industries = [
  {
    "name": "Real Estate & Development",
    "d": "From positioning to digital demand, sales offices to pricing strategy: the goal is sold square metres and increasing project value.",
    "href": "/sectors/real-estate-marketing",
    "img": "/cases/baki-evleri/towers.webp"
  },
  {
    "href": null,
    "name": "Construction & Infrastructure",
    "img": "https://images.unsplash.com/photo-1764536601672-80b15920d5c3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "d": "We translate technical capability into market trust, differentiation and more valuable commercial opportunities."
  },
  {
    "href": null,
    "name": "Entertainment & Experience Businesses",
    "img": "https://images.unsplash.com/photo-1576064535163-095bccc642b2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "d": "We build launch and demand systems that turn attention into interest, interest into sales, and one-time audiences into lasting relationships."
  },
  {
    "href": "/sectors/horeca-marketing",
    "name": "Hospitality & Leisure",
    "img": "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "d": "We connect brand experience, direct demand, repeat visits and revenue in a working commercial system."
  }
];
export const founder = {
  "name": "Zülfinaz Dəmirova",
  "role": "Founder & Strategic Director",
  "photo": "/team/zulfinaz-demirova.webp",
  "bio": [
    "YUXEL gives a name, methodology and company structure to the strategy, positioning, marketing and sales systems Zülfinaz Dəmirova has built for businesses over more than a decade.",
    "This work is not a new beginning. It brings commercial experience from premium property projects, residential developments and business centres into one system for solving larger business problems.",
    "Zülfinaz leads diagnosis, strategic direction, creative decisions and commercial architecture in every engagement. Success is measured through demand, sales, pricing power, occupancy and the quality of business decisions."
  ],
  "practice": [
    "Brand & positioning",
    "Marketing & performance systems",
    "Sales strategy & management",
    "Commercial optimisation"
  ]
};
export const leadRoles = {
  "lead": [
    "Business & growth strategy",
    "Brand & marketing direction",
    "Creative direction",
    "Commercial & sales systems",
    "Analytics & decision systems"
  ],
  "partners": [
    "Video production",
    "Photography",
    "Editing & post-production",
    "Motion design",
    "Technical production & build"
  ]
};
export const framework = [
  {
    "n": "01",
    "t": "Diagnosis",
    "d": "We identify the real constraint on growth across the market, offer, marketing, sales and management."
  },
  {
    "n": "02",
    "t": "Direction",
    "d": "We clarify where the business is going, how it will win and what it should decline."
  },
  {
    "n": "03",
    "t": "Business architecture",
    "d": "We align offers, processes, roles and decision flows around the same growth objective."
  },
  {
    "n": "04",
    "t": "Brand system",
    "d": "We translate real value into a distinctive market position that supports premium pricing."
  },
  {
    "n": "05",
    "t": "Demand system",
    "d": "We turn isolated campaigns into sustained, manageable and measurable demand."
  },
  {
    "n": "06",
    "t": "Sales system",
    "d": "We structure the journey from enquiry to contract and reduce dependence on chance."
  },
  {
    "n": "07",
    "t": "Measurement & scale",
    "d": "We track results, improve weak points and scale the system that works."
  }
];
export const processSteps = [
  {
    "n": "01",
    "t": "Strategic introduction",
    "d": "We clarify the ambition, current position and mutual fit.",
    "w": ""
  },
  {
    "n": "02",
    "t": "Diagnosis",
    "d": "We identify the main constraints across market, brand, marketing, sales and analytics.",
    "w": ""
  },
  {
    "n": "03",
    "t": "Transformation roadmap",
    "d": "We agree priorities, scope, resources, sequence and measures of success.",
    "w": ""
  },
  {
    "n": "04",
    "t": "Build & implement",
    "d": "YUXEL leads strategy and creative direction; the internal team and selected production partners work within that system.",
    "w": ""
  },
  {
    "n": "05",
    "t": "Measurement & scale",
    "d": "We track results, optimise the system and expand the mechanisms that work.",
    "w": ""
  }
];
export const principles = [
  {
    "n": "01",
    "t": "Systems, not silos",
    "d": "Strategy, brand, marketing and sales form one mechanism."
  },
  {
    "n": "02",
    "t": "Results over activity",
    "d": "We measure the change in the business, rather than the volume of visible work."
  },
  {
    "n": "03",
    "t": "Diagnosis before answers",
    "d": "The solution starts once the problem is precisely defined."
  },
  {
    "n": "04",
    "t": "One direction, expert execution",
    "d": "YUXEL manages strategy, with the right specialists delivering technical execution."
  }
];
export const marqueeItems = [
  "Business diagnosis",
  "Growth strategy",
  "Market & competitor analysis",
  "What does YUXEL change?",
  "Brand architecture",
  "Go-to-market strategy",
  "Marketing & demand systems",
  "Sales process & CRM",
  "Offer & pricing strategy",
  "Creative direction",
  "KPIs & analytics",
  "AI automation",
  "Leadership & management systems"
];